import { render, staticRenderFns } from "./AlarmPointHistory.vue?vue&type=template&id=202c3f8b&scoped=true"
import script from "./AlarmPointHistory.vue?vue&type=script&lang=ts"
export * from "./AlarmPointHistory.vue?vue&type=script&lang=ts"
import style0 from "./AlarmPointHistory.vue?vue&type=style&index=0&id=202c3f8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202c3f8b",
  null
  
)

export default component.exports